import {
  ShopperAgentSandboxCustomerMessageSchema,
  ShopperAgentSandboxMessageSchema,
} from "@redotech/redo-model/shopper-agent/sandbox/sandbox-message";
import * as z from "zod";

export const generateSandboxReply = {
  name: "generateSandboxReply" as const,
  input: z
    .object({
      threadId: z.string().nullable(),
      customerId: z.string(),
      message: ShopperAgentSandboxCustomerMessageSchema,
    })
    .strict(),
  output: z.object({
    threadId: z.string(),
    messages: z.array(ShopperAgentSandboxMessageSchema),
  }),
};
